/*jshint esversion: 6 */
const state = {
    config: [],
    loadingDone: false,
};

const mutations = {
    loadConfig(state, config) {
        let constLength = 0;
        constLength = config.length;
        state.config = config [constLength-1]   ;

        state.loadingDone = true;
        console.log("#loadConfig done#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() ); 
    },  
};

const actions = { 
    loadConfig(context, { vm }) {
        const db = vm.$firebase.firestore();
    
        const config = [];
        db.collection("config").onSnapshot(snapshot => {
          let changes = snapshot.docChanges();
          changes.forEach (change => {
            if (change.type == 'modified' | change.type == 'added') {
              config.push({
                id: change.doc.id,
                secretKey: change.doc.data().secretKey,
                version: change.doc.data().version,
              });        
            }
          });  
          //console.log('config loaded')
          context.commit('loadConfig', config);     
        }); 
      },     
   
};
  
const getters = {
    config: state => {
        return state.config;
    },  
    loadingDone: state => {
        return state.loadingDone;
    }  
};

export default {
    state,
    mutations,
    actions,
    getters
};
   